import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { ClientDetailsTab } from "./tabs/ClientDetailsTab";
import { history, store } from "../../../store/store";
import { ClientEditForm } from "./forms/edit/ClientEditForm";
import { ClientOrdersTab } from "./tabs/ClientOrdersTab";
import { ACL } from '../../../config/constants';
import { hideNotification } from '../../../store/actions/notification';
import { ClientOrganizationsTab } from "./tabs/ClientOrganizationsTab";
import { ClientCertificatesTab } from "./tabs/ClientCertificatesTab";
import { EntityTabLayout } from '../../layout/Workspace';

function ClientDetailsComponent(props) {
  const {
    user, updateUser, orders, meta, getUserOrders, rowsPerPageOrders, setRowsPerPageOrders,
    organizations, metaOrganizations, getUserOrganizations, rowsPerPageOrganizations, setRowsPerPageOrganizations,
    certificates, metaCertificates, getUserCertificates, rowsPerPageCertificates, setRowsPerPageCertificates,
  } = props;
  const intl = useIntl();
  const [activeTab, setActiveTab] = useState(ACL.CLIENT.USERS.VIEW.hasAccess() ? 'user' : 'orders');
  const [tabs, setTabs] = useState({ user: false, orders: false, organizations: false, certificates: false });

  useEffect(() => {
    const tab = new URLSearchParams(props.location.search).get("tab");

    if (tab) {
      if (activeTab !== tab) {
        setActiveTab(tab);
      } else {
        resetEditMode();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.search]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      history.push(
        {search: "?" + new URLSearchParams({ tab: tab }).toString()},
        {prevLocation: (history.location.state && history.location.state.prevLocation !== null ? history.location.state.prevLocation : null)}
      );

      store.dispatch(hideNotification());
      setActiveTab(tab);
    }
  };

  const resetEditMode = () => {
    const tabsU = tabs;
    let shouldUpdate = false;

    Object.keys(tabsU).map((key) => {
      if (activeTab !== key && tabsU[key] === true) {
        tabsU[key] = false;
        shouldUpdate = true;
      }

      return true;
    });

    if (shouldUpdate) {
      setTabs(tabsU);
    }
  };

  const toggleEditMode = (target, value) => {
    setTabs({
      ...tabs,
      [target]: value,
    });
  };

  // Reactstrap's previous TabContent kept every tab consumer mounted. Keep that
  // contract so changing tabs does not retrigger fetches or discard local state.
  const tabPanels = (
    <div className="user-detail-tab-panels">
      {ACL.CLIENT.USERS.VIEW.hasAccess() && (
        <div
          aria-hidden={activeTab !== 'user'}
          className="user-detail-tab-panel"
          hidden={activeTab !== 'user'}
        >
          {tabs.user ? (
            <ClientEditForm
              user={user}
              toggleEditMode={toggleEditMode}
              updateUser={updateUser}
            />
          ) : (
            <ClientDetailsTab user={user} toggleEditMode={toggleEditMode}/>
          )}
        </div>
      )}
      {ACL.CLIENT.ORDERS.LIST.hasAccess() && (
        <div
          aria-hidden={activeTab !== 'orders'}
          className="user-detail-tab-panel"
          hidden={activeTab !== 'orders'}
        >
          <ClientOrdersTab
            user={user}
            orders={orders}
            meta={meta}
            getUserOrders={getUserOrders}
            rowsPerPageOrders={rowsPerPageOrders}
            setRowsPerPageOrders={setRowsPerPageOrders}
          />
        </div>
      )}
      {ACL.CLIENT.USERS.LIST.hasAccess() && (
        <div
          aria-hidden={activeTab !== 'organizations'}
          className="user-detail-tab-panel"
          hidden={activeTab !== 'organizations'}
        >
          <ClientOrganizationsTab
            user={user}
            organizations={organizations}
            metaOrganizations={metaOrganizations}
            getUserOrganizations={getUserOrganizations}
            rowsPerPageOrganizations={rowsPerPageOrganizations}
            setRowsPerPageOrganizations={setRowsPerPageOrganizations}
          />
        </div>
      )}
      {ACL.CLIENT.USERS.LIST.hasAccess() && (
        <div
          aria-hidden={activeTab !== 'certificates'}
          className="user-detail-tab-panel"
          hidden={activeTab !== 'certificates'}
        >
          <ClientCertificatesTab
            user={user}
            certificates={certificates}
            metaCertificates={metaCertificates}
            getUserCertificates={getUserCertificates}
            rowsPerPageCertificates={rowsPerPageCertificates}
            setRowsPerPageCertificates={setRowsPerPageCertificates}
          />
        </div>
      )}
    </div>
  );
  const entityTabs = [];

  if (ACL.CLIENT.USERS.VIEW.hasAccess()) {
    entityTabs.push({
      id: 'user',
      label: <FormattedMessage id="fields.user_details"/>,
      content: tabPanels
    });
  }

  if (ACL.CLIENT.ORDERS.LIST.hasAccess()) {
    entityTabs.push({
      id: 'orders',
      label: <FormattedMessage id="fields.user_orders"/>,
      content: tabPanels
    });
  }

  if (ACL.CLIENT.USERS.LIST.hasAccess()) {
    entityTabs.push({
      id: 'organizations',
      label: <FormattedMessage id="fields.user_organizations"/>,
      content: tabPanels
    });
    entityTabs.push({
      id: 'certificates',
      label: <FormattedMessage id="fields.user_certificates"/>,
      content: tabPanels
    });
  }

  const userFullName = user && user.id
    ? [user.first_name, user.last_name].filter(Boolean).join(' ')
    : intl.formatMessage({ id: 'pages.client.title' });

  return (
    <EntityTabLayout
      activeTab={activeTab}
      ariaLabel={userFullName}
      className="user-detail-layout"
      header={props.header}
      onTabChange={toggle}
      tabs={entityTabs}
    />
  );
}

ClientDetailsComponent.defaultProps = {
  header: null
};

const ClientDetails = connect(null, {})(ClientDetailsComponent);

export { ClientDetails, ClientDetailsComponent };
